import { GridRowSelectionModel } from '@mui/x-data-grid-pro'

export enum BulkAction {
  Update = 'update',
  Deactivate = 'deactivate',
  CloseCards = 'close virtual cards',
}

interface BulkActionReturn {
  handleCheckboxClick: (selection: GridRowSelectionModel) => void
  handleBulkAction: (bulkAction?: BulkAction) => void
}

const areStringIdsEqualAsSet = (left: string[], right: string[]): boolean => {
  if (left === right) return true
  if (left.length !== right.length) return false
  const leftSet = new Set(left)
  if (leftSet.size !== right.length) return false
  return right.every((id) => leftSet.has(id))
}

export const useBulkAction = (
  selectedIds: string[],
  updateProps: {
    updateSelectedIds: (selectedIds: string[]) => void
    analyticsEvent?: () => void
    limitCondition?: boolean
    limitFunction?: () => void
  },
  bulkActionProps: {
    bulkAction: (selectedIds: string[]) => void
    analyticsEvent?: (bulkAction?: BulkAction) => void
  },
): BulkActionReturn => {
  const handleCheckboxClick = (selection: GridRowSelectionModel): void => {
    if (updateProps.limitCondition) {
      // logic to handle limit condition
      if (updateProps.limitFunction) {
        updateProps.limitFunction()
      }
    } else {
      const nextSelectedIds = [...selection.ids].map((id) => id.toString())
      if (areStringIdsEqualAsSet(nextSelectedIds, selectedIds)) return

      // logic to handle checkbox click
      if (updateProps.analyticsEvent) {
        updateProps.analyticsEvent()
      }
      updateProps.updateSelectedIds(nextSelectedIds)
    }
  }
  const handleBulkAction = (bulkAction?: BulkAction): void => {
    // logic to handle bulk action
    if (bulkActionProps.analyticsEvent) {
      bulkActionProps.analyticsEvent(bulkAction)
    }
    bulkActionProps.bulkAction(selectedIds)
    // next step in logic is the bulk update/deactivate virtual cards flyout/popup open useEffect
  }

  return {
    handleCheckboxClick,
    handleBulkAction,
  }
}
